import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";

interface PricingCardProps {
  level: string;
  title: string;
  price: string;
  priceNote?: string;
  description: string;
  features: string[];
  cta: string;
  ctaLink: string;
  highlighted?: boolean;
  badge?: string;
}

export const PricingCard = ({
  level,
  title,
  price,
  priceNote,
  description,
  features,
  cta,
  ctaLink,
  highlighted = false,
  badge,
}: PricingCardProps) => {
  return (
    <div
      className={`card-premium relative flex flex-col h-full ${
        highlighted ? "ring-2 ring-primary" : ""
      }`}
    >
      {badge && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2">
          <span className="inline-block bg-primary text-primary-foreground text-xs font-semibold px-3 py-1 rounded-full">
            {badge}
          </span>
        </div>
      )}

      <div className="mb-6">
        <span className="text-xs font-medium text-primary uppercase tracking-wider">
          {level}
        </span>
        <h3 className="font-display text-xl font-semibold text-foreground mt-2 mb-2">
          {title}
        </h3>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>

      <div className="mb-6">
        <div className="flex items-baseline gap-1">
          <span className="text-3xl font-bold text-foreground">{price}</span>
        </div>
        {priceNote && (
          <p className="text-sm text-muted-foreground mt-1">{priceNote}</p>
        )}
      </div>

      <ul className="space-y-3 mb-8 flex-1">
        {features.map((feature, index) => (
          <li key={index} className="flex items-start gap-3">
            <Check className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
            <span className="text-sm text-foreground">{feature}</span>
          </li>
        ))}
      </ul>

      <Link to={ctaLink} className="mt-auto">
        <Button
          variant={highlighted ? "hero" : "outline"}
          className="w-full"
          size="lg"
        >
          {cta}
        </Button>
      </Link>
    </div>
  );
};
